export default "__VITE_ASSET__1g_uYxQ7__"